import { SettingsGroup } from './settings-menu.model';

export const SETTINGS_GROUPS: SettingsGroup[] = [
    {
        label: 'Usuarios y seguridad',
        items: [
            { label: 'Grupos', icon: 'pi pi-users', routerLink: '/groups', permission: 'GROUPS.ACCESS' },
            { label: 'Roles', icon: 'pi pi-shield', routerLink: '/roles', permission: 'ROLES.ACCESS' },
            { label: 'Servicios de autenticación', icon: 'pi pi-verified', routerLink: '/authentications-services', permission: 'AUTHENTICATION_SERVICES.ACCESS' },
            { label: 'Usuarios', icon: 'pi pi-users', routerLink: '/users', permission: 'USERS.ACCESS' },
        ],
    },
    {
        label: 'Organización y empresa',
        items: [
            { label: 'Bancos', icon: 'pi pi-euro', routerLink: '/banks', permission: 'BANKS.ACCESS' },
            { label: 'Centros de coste', icon: 'pi pi-building', routerLink: '/costsCenters', permission: 'COSTS_CENTERS.ACCESS' },
            { label: 'Configuraciones empresa', icon: 'pi pi-sliders-v', routerLink: '/configurations', permission: 'COMPANY_CONFIGURATIONS.ACCESS' },
            { label: 'Delegaciones', icon: 'pi pi-building', routerLink: '/delegations', permission: 'DELEGATIONS.ACCESS' },
            { label: 'Protección de datos', icon: 'pi pi-shield', routerLink: '/dataProtection', permission: 'PROTECTION_DATA.ACCESS' },
            { label: 'Sociedades', icon: 'pi pi-warehouse', routerLink: '/business', permission: 'BUSINESS.ACCESS' },
            { label: 'Zonas', icon: 'pi pi-map', routerLink: '/zones', permission: 'ZONES.ACCESS' },
        ],
    },
    {
        label: 'Facturación y precios',
        items: [
            { label: 'Baremos de compañía', icon: 'pi pi-sliders-h', routerLink: '/rates/COMPANY', permission: 'COMPANY_RATES.ACCESS' },
            { label: 'Baremos de operario', icon: 'pi pi-sliders-h', routerLink: '/rates/WORKER', permission: 'WORKER_RATES.ACCESS' },
            { label: 'Baremos de proveedor', icon: 'pi pi-sliders-h', routerLink: '/rates/PROVIDER', permission: 'PROVIDER_RATES.ACCESS' },
            { label: 'Impuestos', icon: 'pi pi-money-bill', routerLink: '/taxes', permission: 'TAXES.ACCESS' },
            { label: 'Precios', icon: 'pi pi-tag', routerLink: '/products', permission: 'PRODUCTS.ACCESS' },
            { label: 'Razón de revisión transacción', icon: 'pi pi-clipboard', routerLink: '/transactionsRevisionReasons', permission: 'TRANSACTIONS_REVISION_REASONS.ACCESS' },
            { label: 'Series', icon: 'pi pi-wallet', routerLink: '/transactionsSeries', permission: 'TRANSACTION_SERIES.ACCESS' },
        ],
    },
    {
        label: 'Expedientes',
        items: [
            { label: 'Categoría de eventos', icon: 'pi pi-flag', routerLink: '/casesLogTypes', permission: 'CASES_LOGS_TYPES.ACCESS' },
            { label: 'Estados de expediente', icon: 'pi pi-chart-line', routerLink: '/casesStates', permission: 'CASES_STATES.ACCESS' },
            { label: 'Motivos de cancelación y citas atrasadas', icon: 'pi pi-calendar-times', routerLink: '/casesServicesCauses', permission: 'CASES_SERVICES_REASONS.ACCESS' },
            { label: 'Tipos de incidencias', icon: 'pi pi-chart-line', routerLink: '/incidentsTypes', permission: 'INCIDENT_TYPES.ACCESS' },
            { label: 'Tipos de servicios', icon: 'pi pi-clipboard', routerLink: '/servicesTypes', permission: 'SERVICES_TYPES.ACCESS' },
            { label: 'Tratamientos expedientes', icon: 'pi pi-cart-plus', routerLink: '/casesTreatments', permission: 'CASES_TREATMENTS.ACCESS' },
        ],
    },
    {
        label: 'Operarios y RRHH',
        items: [
            { label: 'Categorías profesionales', icon: 'pi pi-briefcase', routerLink: '/professional-categories', permission: 'PROFESSIONAL_CATEGORIES.ACCESS' },
            { label: 'Convenio colectivo', icon: 'pi pi-file', routerLink: '/colective-agreements', permission: 'COLECTIVE_AGREEMENT.ACCESS' },
            { label: 'Equipamiento', icon: 'pi pi-wrench', routerLink: '/equipments', permission: 'EQUIPMENTS.ACCESS' },
            { label: 'Materiales', icon: 'pi pi-box', routerLink: '/materials', permission: 'MATERIALS.ACCESS' },
            { label: 'Especialidades', icon: 'pi pi-list', routerLink: '/capabilities', permission: 'CAPABILITIES.ACCESS' },
            { label: 'Razones de baja de operario', icon: 'pi pi-user-minus', routerLink: '/workerEndReasons', permission: 'WORKERS_END_REASONS.ACCESS' },
        ],
    },
    {
        label: 'Clientes y comercial',
        items: [
            { label: 'Encuestas', icon: 'pi pi-check-square', routerLink: '/surveys', permission: 'SURVEYS.ACCESS' },
            { label: 'Origen de clientes', icon: 'pi pi-inbox', routerLink: '/thirdPartiesSources', permission: 'THIRD_PARTIES_SOURCES.ACCESS' },
            { label: 'Ramo', icon: 'pi pi-sitemap', routerLink: '/trades', permission: 'TRADES.ACCESS' },
        ],
    },
    {
        label: 'Comunicaciones',
        items: [
            { label: 'Cuentas de correo', icon: 'pi pi-envelope', routerLink: '/mailsAccounts', permission: 'MAIL_ACCOUNTS.ACCESS' },
            { label: 'Plantillas', icon: 'pi pi-sitemap', routerLink: '/templates', permission: 'TEMPLATES.ACCESS' },
        ],
    },
    {
        label: 'Vehículos',
        items: [
            { label: 'Tipos de vehículos', icon: 'pi pi-car', routerLink: '/vehiclesTypes', permission: 'VEHICLE_TYPES.ACCESS' },
            { label: 'Vehículos', icon: 'pi pi-car', routerLink: '/vehicles', permission: 'VEHICLES.ACCESS' },
        ],
    },
    {
        label: 'Datos y automatización',
        items: [
            { label: 'Automatizaciones', icon: 'pi pi-cog', routerLink: '/automations', permission: 'AUTOMATIONS.ACCESS' },
            { label: 'Importaciones', icon: 'pi pi-upload', routerLink: '/imports', permission: 'IMPORTS.ACCESS' },
        ],
    },
    {
        label: 'Plataforma',
        items: [
            { label: 'Salud de la plataforma', icon: 'pi pi-chart-bar', routerLink: '/platformHealth', permission: 'PLATFORM_HEALTH.DATABASE' },
            { label: 'Logs de servicios', icon: 'pi pi-align-left', routerLink: '/serviceLogs', permission: 'SERVICE_LOGS.ACCESS' },
        ],
    },
];

/** Todas las rutas (routerLink) de las subopciones de configuración. */
export const SETTINGS_ROUTES: string[] = SETTINGS_GROUPS.flatMap((group) =>
    group.items.map((item) => item.routerLink),
);

/**
 * Indica si una ruta pertenece a una subopción de configuración (listado o
 * detalle). Se usa para pintar el acceso a "Configuración" en el breadcrumb.
 */
export function isSettingsRoute(path: string): boolean {
    const clean = path.split('?')[0].split('#')[0];
    return SETTINGS_ROUTES.some((base) => clean === base || clean.startsWith(base + '/'));
}
